import { UserRoles } from '@shared/services/apiService';

export const UserRolesEnum: Record<Uppercase<UserRoles>, UserRoles> = {
  ADMIN: 'admin',
  VIEWER: 'viewer',
} as const;
